module.exports = __webpack_public_path__ + "img/logo_us_principal.0fa607ed.svg";